import { useEffect, useRef } from 'react';
import { createTranscriber, isSpeechSupported, type Transcriber } from './voiceFollow.js';

/**
 * Presenter-side transcript capture for the "living log". Runs the browser speech
 * recogniser while `active` is true and forwards each finalised line to `onLine`
 * (the presenter streams them to the server, which only stores them if the producer
 * opted the show into recording). Needs microphone permission + a Chrome-family
 * browser; silently does nothing where unsupported.
 */
export function useTranscript(active: boolean, onLine: (text: string) => void): { supported: boolean } {
  const supported = isSpeechSupported();
  const ref = useRef<Transcriber | null>(null);
  const cb = useRef(onLine);
  cb.current = onLine;

  useEffect(() => {
    if (!active || !supported) return;
    const t = createTranscriber('en-AU', (text) => cb.current(text));
    if (!t) return;
    ref.current = t;
    t.start();
    return () => {
      t.stop();
      ref.current = null;
    };
  }, [active, supported]);

  return { supported };
}
